import datagridStyles from '../../Datagrid/Datagrid.styles';

const styles = {
  searchField: {
    minWidth: 360,
    mr: '30px'
  },
  searchInput: {
    pr: '20px'
  },
  qcStatusControl: {
    minWidth: '280px',
    mr: '20px'
  },
  qcStatusSelect: {
    p: '0'
  },
  searchButton: {
    textTransform: 'none'
  },
  headerActionsBox: {
    ml: 'auto'
  },
  dataGridContainer: {
    minHeight: 640,
    height: 640
  },
  dataGrid: {
    ...datagridStyles.datagrid,
    '& .MuiDataGrid-cell:focus': { outline: 'none' },
    '& .MuiDataGrid-cell:focus-within': { outline: 'none' }
  }
};

export default styles;
